import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InputAdornment, OutlinedInput } from "@material-ui/core";
import { IInputWithIcon, IStyle } from "../../types";

const InputWithIconWrapper = styled.div<IStyle>`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  @media screen and (max-width: 930px) {
    width: ${(props) => (props.isSummary ? "inherit" : "100%")};
  }
`;

const BackgroundInput = styled.div<IStyle>`
  width: ${(props) => (props.isSummary ? "100%" : "300px")};
  height: 56px;
  /* margin: 0 auto; */
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 4px;
`;

const TextInput = styled(OutlinedInput)<IStyle>`
  width: 300px;
  background: ${(props) =>
    props.disabled ? props.theme.primaryColor + 20 : ""};
  border-radius: 4px;

  input {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    fill: ${(props) => props.theme.disabledColor};
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.disabled
        ? props.theme.primaryColor + 20
        : props.theme.disabledColor} !important;
  }

  @media screen and (max-width: 930px) {
    width: 100%;
  }
`;

const InputWithIconLayout = (props: IInputWithIcon) => {
  const { i18n } = useTranslation();
  const { readOnly = true, name = "input", isSummary } = props;
  return (
    <InputWithIconWrapper
      data-test="text-icon-wrapper"
      isSummary={isSummary}
      className="input-with-icon"
    >
      <BackgroundInput isSummary={isSummary}>
        <TextInput
          name={name}
          error={props.error}
          value={
            props.value === 0 || (props.isNumeric && isNaN(props.value))
              ? ""
              : props.value
          }
          label={props.label}
          placeholder={props.placeholderKey ? i18n.t(props.placeholderKey) : ""}
          onChange={props.onChange}
          onClick={props.onClick}
          disabled={isSummary}
          endAdornment={
            <InputAdornment position="end">{props.icon}</InputAdornment>
          }
          inputProps={{
            readOnly: readOnly,
          }}
          data-test={props.dataTest ?? ""}
        />
      </BackgroundInput>
    </InputWithIconWrapper>
  );
};

export const InputWithIcon = memo(InputWithIconLayout);
